import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';

import {
  BRAND_ROUTE,
  COLLECTION_LIST_ROUTE,
  COVER_IMAGE_ROUTE,
  DESTINATION_LIST_ROUTE,
  DOCUMENT_ROUTE,
  EXPIRED_CART_ROUTE,
  EXTERNAL_LINK_ROUTE,
  FEATURED_PRODUCTS_ROUTE,
  GROUPS_ROUTE,
  MESSAGE_ROUTE,
  NEWS_ROUTE,
  ROLE_ROUTE,
  SEASON_LIST_ROUTE,
  SEASON_WORKBENCH_LIST_ROUTE,
  STATIC_CONTENT_ROUTE,
  USER_ROUTE,
  WEB_SERVICE_ROUTE,
} from '../../../constants/app-url-constants';
import { MenuData } from '../models/menu.model';
import {
  menuListUrl,
  menuSecurityUrl,
} from './../../../constants/url-constants';
import { Base64Service } from './base64.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private data: MenuData[] = [];
  constructor(
    private translate: TranslateService,
    private httpClient: HttpClient,
    private $sessionStorageService: SessionStorageService,
    private base64Service: Base64Service
  ) {
    this.setUserAdministratorMenu();
    this.setContentMenu();
    this.setProductsMenu();
    this.setSiteAdminMenu();
    this.setDynamicDestinationMenu();
  }

  getMenuData() {
    return this.httpClient.get(menuListUrl);
  }

  setUserAdministratorMenu() {
    this.data.push({
      name: this.translate.instant('menu.userAdministration'),
      children: [
        { name: this.translate.instant('label.group'), route: GROUPS_ROUTE },
        { name: this.translate.instant('label.users'), route: USER_ROUTE },
        { name: this.translate.instant('label.roles'), route: ROLE_ROUTE },
      ],
    });
  }

  setContentMenu() {
    this.data.push({
      name: this.translate.instant('menu.content'),
      children: [
        {
          name: this.translate.instant('label.documents'),
          route: DOCUMENT_ROUTE,
        },
        {
          name: this.translate.instant('label.externalLinks'),
          route: EXTERNAL_LINK_ROUTE,
        },
        {
          name: this.translate.instant('label.messages'),
          route: MESSAGE_ROUTE,
        },
        { name: this.translate.instant('label.news'), route: NEWS_ROUTE },
        {
          name: this.translate.instant('label.staticContent'),
          route: STATIC_CONTENT_ROUTE,
        },
        {
          name: this.translate.instant('label.loginPage'),
          route: COVER_IMAGE_ROUTE,
        },
      ],
    });
  }

  setProductsMenu() {
    this.data.push({
      name: this.translate.instant('menu.products'),
      children: [
        {
          name: this.translate.instant('label.collection'),
          route: COLLECTION_LIST_ROUTE,
        },
        {
          name: this.translate.instant('label.featuredProducts'),
          route: FEATURED_PRODUCTS_ROUTE,
        },
        {
          name: this.translate.instant('label.seasonWorkbench'),
          route: SEASON_WORKBENCH_LIST_ROUTE,
        },
        {
          name: this.translate.instant('label.seasons'),
          route: SEASON_LIST_ROUTE,
        },
        {
          name: this.translate.instant('label.expiredCarts'),
          route: EXPIRED_CART_ROUTE,
        },
      ],
    });
  }

  setSiteAdminMenu() {
    this.data.push({
      name: this.translate.instant('menu.siteAdministration'),
      children: [
        { name: this.translate.instant('label.brand'), route: BRAND_ROUTE },
      ],
    });
  }
  setDynamicDestinationMenu() {
    this.data.push({
      name: this.translate.instant('menu.dynamicDestination'),
      children: [
        {
          name: this.translate.instant('label.destination'),
          route: DESTINATION_LIST_ROUTE,
        },
        {
          name: this.translate.instant('label.webServices'),
          route: WEB_SERVICE_ROUTE,
        },
      ],
    });
  }
  getMenuForSecurityList() {
    return new Promise((resolve, reject) => {
      if (this.$sessionStorageService.retrieve('url-allowed')) {
        resolve(
          this.base64Service
            .decodeString(this.$sessionStorageService.retrieve('url-allowed'))
            .split(',')
        );
      } else {
        this.getMenuSecurityData().subscribe(
          (response: any) => {
            this.storeDataToStorage(response);
            resolve(response.data);
          },
          (error) => {
            reject(false);
          }
        );
      }
    });
  }
  getMenuSecurityData() {
    return this.httpClient.get(menuSecurityUrl);
  }
  private storeDataToStorage(response) {
    if (response && response.data && response.data.length) {
      this.$sessionStorageService.store(
        'url-allowed',
        this.base64Service.encodeString(response.data.toString())
      );
    }
  }
}
